// src/config.ts
export interface ServicesConfig {
    host: string;
    // Add more service-related configurations as needed
}

export interface AppConfig {
    services: ServicesConfig;
    // Add other configuration categories as needed
}

const config: AppConfig = {
    services: {
        host: import.meta.env.VITE_BACKEND_HOST,
    },
    // Initialize other configurations here
};

export default config;